import { render, staticRenderFns } from "./Zoom.vue?vue&type=template&id=59b871b8&scoped=true&"
import script from "./Zoom.vue?vue&type=script&lang=js&"
export * from "./Zoom.vue?vue&type=script&lang=js&"
import style0 from "./Zoom.vue?vue&type=style&index=0&id=59b871b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b871b8",
  null
  
)

export default component.exports